import { CommonUtilsService } from 'util/services/commonUtilsService';
import { IDictionary, Action } from 'util/domain';


interface PendingAction {
	id:string,
	context:string,
	phrase:string,
	timestamp:number,
	scope:PendingActionScope
}

export enum PendingActionScope {
	All = 0,
	AppClose = 0x01,
	Logout = 0x02,
	StateChange = 0x04
}


export class PendingActionsService{
	public static $inject = [
		'utils',
		'gettextCatalog'
	]

	private disabled = false;
	private messageStack:PendingAction[] = [];
	
    constructor(
		private readonly utils:CommonUtilsService,
		private readonly gettextCatalog:any
	){}
	
	public get message():string {
		return this.messageStack.length < 1 ? 
			this.gettextCatalog.getString('All pending actions have completed. You may log off safely now.') :
			this.messageStack[this.messageStack.length - 1].phrase;			
	} 

	public getMessageBy(scope:PendingActionScope){
		let lastMessage;

		for(let i = this.messageStack.length - 1; !lastMessage && i >= 0; i--){
			let a = this.messageStack[i];
			if(this.hasScope(a, scope)){
				lastMessage = a.phrase;
			}
		}

		return lastMessage;
	}

	public get unsavedChanges():boolean {
		return !this.disabled && this.messageStack.length > 0; 
	};

	public addMessage(message:string, context:string, scope:PendingActionScope = PendingActionScope.AppClose & PendingActionScope.Logout):Action {
		let action:PendingAction = {
			id: this.utils.generateUid(),
			context: context,
			phrase: message,
			timestamp: Date.now(),
			scope
		}

		this.messageStack.push(action);

		return this.createRemover(action).bind(this);
	}
	
	public clearMessages() {
		this.messageStack = [];
	}

	public clearBy(scope:PendingActionScope){
		this.messageStack = this.messageStack.filter(a => !this.hasScope(a, scope));
	}

	/**
	 * Disable any pending action messages from displaying on browser navigation. Returns a function
	 * that can be called to renable the messages.
	 */
	public disablePendingMessages(): Action {
		this.disabled = true;
		return () => this.disabled = false;
	}

	private createRemover(action:PendingAction){
		return () => {
			let i = this.messageStack.indexOf(action);
			if(i > -1){
				this.messageStack.splice(i, 1);
			}
			else {
				throw new Error('Pending action already removed.');
			}
		};
	}

	private hasScope(action:PendingAction, scope:PendingActionScope){
		return action.scope === PendingActionScope.All ? true : (action.scope & scope) !== 0;
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/pendingActionsService.ts